<template>
  <div class="card">
    <img :src="image_url"  class="card-image" @load="handleImageLoad" @error="handleImageError">
    <div class="card-details">
      <h2 class="card-title">{{ name }}</h2>
      <p class="card-price">{{ price }}€</p>
      <div class="button-detail-container">
        <button @click="toggleDescription" class="card-button">{{ isDescriptionVisible ? 'Chiudi Dettagli' : 'Dettagli' }}</button>
      </div>
      <div v-if="isDescriptionVisible" class="card-description">
        <p>{{ description }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    image_url: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    price: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isDescriptionVisible: false,
      isImageLoaded: false, // Aggiungi una nuova variabile di stato per tenere traccia del caricamento dell'immagine
      isImageError: false // Aggiungi una nuova variabile di stato per tenere traccia dell'errore di caricamento dell'immagine
    };
  },
  methods: {
    toggleDescription() {
      this.isDescriptionVisible = !this.isDescriptionVisible;
    },
    handleImageLoad() {
      this.isImageLoaded = true; // Imposta la variabile di stato su true quando l'immagine è stata caricata con successo
    },
    handleImageError() {
      this.isImageError = true; // Imposta la variabile di stato su true se si verifica un errore durante il caricamento dell'immagine
    }
  }
};
</script>

<style scoped>
.card {
  background-color: var(--primary-color);
  border-radius: 20px;
  box-shadow: var(--custom-box-shadow);
  overflow: hidden;
  transition: transform 0.3s ease;
  max-width: 85vw;
  margin: auto;
  margin-bottom: 60px;
}

.card:hover {
  transform: translateY(-5px);
}

.card-image {
  width: 100%;
  height: auto;
}

.card-details {
  padding: 20px;
}

.card-title {
  color: var(--text-color);
  font-size: 1.5rem;
  margin-bottom: 10px;
}

.card-price {
  color: var(--accent-color);
  font-size: 1.2rem;
  margin-bottom: 10px;
}

.button-detail-container {
  display: flex;
}

.card-button {
  background-color: var(--accent-color);
  color: var(--text-color);
  border: none;
  border-radius: 5px;
  padding: 10px 20px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-left: auto; 
}

.card-button:hover {
  background-color: var(--accent-color-clicked);
}

.card-description {
  color: var(--text-color);
  background-color: var(--secondary-color);
  border-radius: 10px;
  padding: 20px;
  margin-top: 10px;
}

.close {
  float: right;
  font-size: 1.5rem;
  cursor: pointer;
}
</style>
